import apiClient from "./client";

export default {
  // Devices (list for current customer from token/claim)
getDevices: async () => {
  const response = await apiClient.get("/iot/devices")
  return response.data
},
  getDevice: (id) => apiClient.get(`/iot/devices/${id}`),
  createDevice: (data) => apiClient.post("/iot/devices", data),
  updateDevice: (id, data) => apiClient.put(`/iot/devices/${id}`, data),
  deleteDevice: (id) => apiClient.delete(`/iot/devices/${id}`),
  getDeviceTypes: async () => {
    const response = await apiClient.get("/iot/devices/types");
    return response.data;
  },

  // Map of DeviceId → ISO timestamp of most recent reading in Cosmos.
  // Devices that have never been seen are omitted from the response.
  getDevicesFreshness: async () => {
    const response = await apiClient.get("/iot/devices/freshness");
    return response.data;
  },

  // Time-series (calibrated) for PIP / DING
  getSeries: (payload) => apiClient.post("/iot/dashboard/get", payload),

  // PDF export (DinkToPdf). payload: { deviceId, deviceType: 'PIP'|'DING', fromUtcMs, toUtcMs, customerId? }
  exportPdf: (payload) =>
    apiClient.post("/iot/export/pdf", payload, { responseType: "blob" }),

  getDaily:  (payload) => apiClient.post('/iot/dashboard/daily', payload),
  getDOW:    (payload) => apiClient.post('/iot/dashboard/dow', payload),

  // Widgets
  getWidgets: async (deviceId) => {
    const response = await apiClient.get(`/iot/dashboard/widgets/${deviceId}`)
    return response.data
  },
};

